import React from 'react';
import Select from './../Select';
import isEqual from 'lodash-es/isEqual';
import {set, get} from '../../../utils/dotutils';
import PropTypes from 'prop-types';
import CheckBoxGroup from "../CheckBoxGroup";
import CashPayment from "./CashPayment";
import VoucherPayment from "./VoucherPayment";
import SwapPayment from "./SwapPayment";
import BankcardPayment from "./BankcardPayment";
import AdvanceTransferPayment from "./AdvanceTransferPayment";
import CodPayment from "./CodPayment";
import TransferPayment from "./TransferPayment";

const paymentExtraFunc = (type, optionIndex, props) => {
    let Type = null;
    switch (type) {
        case "SwapPayment": Type = SwapPayment; break;
        case "VoucherPayment": Type = VoucherPayment; break;
        case "Cash": Type = CashPayment; break;
        case "Bankcard": Type = BankcardPayment; break;
        case "AdvanceTransfer": Type = AdvanceTransferPayment; break;
        case "Cod": Type = CodPayment; break;
        case "Transfer": Type = TransferPayment; break;
    }
    const option = (props.value || []).find((v) => v.serviceprovider_type === type);
    let _optionIndex = optionIndex;
    if (_optionIndex === -1) {
        _optionIndex = (props.value || []).length;
    }
    return optionIndex !== -1 && <Type {...props} option={option} optionIndex={_optionIndex} />
};

class PaymentsControl extends React.Component {

    static propTypes = {
        required: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
        value: PropTypes.any,
        fields: PropTypes.array,
        layout: PropTypes.any,
        providerTheme: PropTypes.oneOf(["select","radio"]),
    }

    setFieldValue = (field, value) => {
        let oldValue = get(this.props.value, field);
        if (!isEqual(oldValue, value)) {
            const v = Array.isArray(this.props.value) ? [...this.props.value] : (this.props.value ? {...this.props.value} : []);
            set(v, field, value);
            this.props.saveChanges((this.props.name || 'payments'), v);
        }
    }

    providerTheme = (name) => {
        const theme = this.props.providerTheme || "select";
        const valuesOptions = (this.props.value || []).map((value) => {
            return value.serviceprovider_type;
        }).filter((value) => value !== null && value !== undefined);
        const cost = parseFloat(this.props.cost || 0);
        const rounding = parseFloat(this.props.rounding || 0);
        const overpay = parseFloat(this.props.overpay || 0);
        const total = parseFloat(this.props.total || 0);
        if (theme === "select") {
            return <Select
                required={this.props.required === true || (Array.isArray(this.props.required) && this.props.required.indexOf("serviceprovider_type") !== -1)}
                name={name + "serviceprovider_type"}
                component="PaymentServiceProvider"
                storeType="local"
                labelKey="methodname"
                valueKey="id"
                isMulti={true}
                objectValue={false}
                options={this.props.availableProviders}
                value={valuesOptions}
                saveChanges={(name, value) => {
                    const options = (value || []);
                    value = (this.props.value || []).filter((v) => options.indexOf(v.serviceprovider_type) !== -1);
                    this.props.saveChanges((this.props.name || 'payments'), value);
                }}
                label="Fizetés módja"
            />;
        } else if(theme === "radio") {
            if (name !== '') {
                name += '.';
            }
            return <CheckBoxGroup
                required={this.props.required === true || (Array.isArray(this.props.required) && this.props.required.indexOf("serviceprovider_type") !== -1)}
                name={name + "serviceprovider_type"}
                component="PaymentServiceProvider"
                labelKey="methodname"
                valueKey="id"
                objectValue={false}
                options={this.props.availableProviders}
                value={valuesOptions}
                optionProps={({optionValue}) => {
                    if (valuesOptions.indexOf(optionValue) !== -1) {
                        return {};
                    }
                    if (!total) {
                        return {disabled: true};
                    }
                    if((this.props.value || []).length) {
                        if ((total === cost + rounding || total < cost + overpay) && valuesOptions.indexOf(optionValue) === -1) {
                            return {disabled: true};
                        }
                    }
                }}
                optionExtra={{
                    "SwapPayment": ({optionValue, optionIndex}) => paymentExtraFunc("SwapPayment", optionIndex, {value: this.props.value, total, cost, rounding, overpay, setFieldValue: this.setFieldValue, required: this.props.required}),
                    "VoucherPayment": ({optionValue, optionIndex}) => paymentExtraFunc("VoucherPayment", optionIndex, {value: this.props.value, total, cost, rounding, overpay, setFieldValue: this.setFieldValue, required: this.props.required}),
                    "Cash": ({optionValue, optionIndex}) => paymentExtraFunc("Cash", optionIndex, {value: this.props.value, total, cost, rounding, overpay, setFieldValue: this.setFieldValue, required: this.props.required}),
                    "Bankcard": ({optionValue, optionIndex}) => paymentExtraFunc("Bankcard", optionIndex, {value: this.props.value, total, cost, rounding, overpay, setFieldValue: this.setFieldValue, required: this.props.required}),
                    "AdvanceTransfer": ({optionValue, optionIndex}) => paymentExtraFunc("AdvanceTransfer", optionIndex, {value: this.props.value, total, cost, rounding, overpay, setFieldValue: this.setFieldValue, required: this.props.required}),
                    "Cod": ({optionValue, optionIndex}) => paymentExtraFunc("Cod", optionIndex, {value: this.props.value, total, cost, rounding, overpay, setFieldValue: this.setFieldValue, required: this.props.required}),
                    "Transfer": ({optionValue, optionIndex}) => paymentExtraFunc("Transfer", optionIndex, {value: this.props.value, total, cost, rounding, overpay, setFieldValue: this.setFieldValue, required: this.props.required}),
                }}
                saveChanges={(name, value) => {
                    const options = (value || []);
                    value = (this.props.value || []).filter((v) => options.indexOf(v.serviceprovider_type) !== -1);
                    const ownValues = value.map((v) => v.serviceprovider_type);
                    options.map((option) => {
                        if (ownValues.indexOf(option) === -1) {
                            value.push({serviceprovider_type: option});
                        }
                    });
                    this.props.saveChanges((this.props.name || 'payments'), value);
                }}
                label="Fizetés módja"
            />
        }
    }

    getLayout = (fields, name) => {
        return <div className="col-md-12">
            {this.providerTheme(name)}
        </div>;
    }

    render() {
        const fields = this.props.fields || ['method', 'amount'];
        let name = this.props.name || 'payment';
        return this.props.layout ? this.props.layout(fields, name) : this.getLayout(fields, name);
    }

}

export default PaymentsControl;